/* eslint-disable no-restricted-globals */
import React, { useContext, useEffect, useState } from "react";
import { Formik } from "formik";
import { Input, Checkbox, Radio, Select, InputNumber } from "formik-antd";
import axios from "axios";
import _ from "lodash";
import {
  Row,
  Col,
  Button,
  Divider,
  Typography,
  Space,
  DatePicker,
  Alert,
  message,
} from "antd";
import MultiStepFormContext from "./MultiStepFormContext";
import dayjs from "dayjs";
import { Backdrop, CircularProgress } from "@mui/material";
import { stateOptions, cityOptions } from "../../utils/locationOptions";

const Details = () => {
  const {
    details,
    setDetails,
    setApplicationId,
    stepIsValid,
    setStepIsValid,
    next,
    setStepDisable,
  } = useContext(MultiStepFormContext);
  const [alertVisible, setAlertVisible] = useState(false);
  const [alertType, setAlertType] = useState("success");
  const [loading, setLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState("Data Saved Successfully!!");
  const [addressChecked, setAddressChecked] = useState(false);
  const [contactInfoChecked, setContactInfoChecked] = useState(false);

  const handleClose = () => {
    setAlertVisible(false);
  };
  useEffect(() => {}, []);

  const onChangeDOB = (date, dateString) => {
    if (dateString == "") {
      setvalue("dateOfBirth", undefined);
    } else {
      setvalue("dateOfBirth", dayjs(dateString));
    }
  };

  const onChangeNumber = (item, value) => {
    setvalue(item, value);
  };

  const onAddressCheckChange = (e) => {
    if (e.target.checked) {
      setAddressChecked(true);
      setvalue(
        "permanentAddressLine1",
        details["currentAddressLine1"]["value"]
      );
      setvalue(
        "permanentAddressLine2",
        details["currentAddressLine2"]["value"]
      );
      setvalue("permanentLandmark", details["currentLandmark"]["value"]);
      setvalue("permanentVillageArea", details["currentVillageArea"]["value"]);
      setvalue("permanentBlockTaluka", details["currentBlockTaluka"]["value"]);
      setvalue("permanentDistrict", details["currentDistrict"]["value"]);
      setvalue("permanentState", details["currentState"]["value"]);
      setvalue("permanentPincode", details["currentPincode"]["value"]);
    } else {
      setAddressChecked(false);
      setvalue("permanentAddressLine1", "");
      setvalue("permanentAddressLine2", "");
      setvalue("permanentLandmark", "");
      setvalue("permanentVillageArea", "");
      setvalue("permanentBlockTaluka", "");
      setvalue("permanentDistrict", "");
      setvalue("permanentState", "");
      setvalue("permanentPincode", "");
    }
  };

  const onContactCheckChange = (e) => {
    if (e.target.checked) {
      setContactInfoChecked(true);
      setvalue(
        "permanentContactPersonName",
        details["currentContactPersonName"]["value"]
      );
      setvalue(
        "permanentContactPersonRelationship",
        details["currentContactPersonRelationship"]["value"]
      );
      setvalue(
        "permanentContactPersonLandline",
        details["currentContactPersonLandline"]["value"]
      );
      setvalue(
        "permanentContactPersonMobile",
        details["currentContactPersonMobile"]["value"]
      );
      setvalue(
        "permanentContactPersonEmail",
        details["currentContactPersonEmail"]["value"]
      );
    } else {
      setContactInfoChecked(false);
      setvalue("permanentContactPersonName", "");
      setvalue("permanentContactPersonRelationship", "");
      setvalue("permanentContactPersonLandline", "");
      setvalue("permanentContactPersonMobile", "");
      setvalue("permanentContactPersonEmail", "");
    }
  };

  function setvalue(key, value) {
    var x = details;
    x[key].value = value;
    setDetails({ ...x });
  }

  function setvisible(key) {
    var x = details;
    x[key].visible = true;
    setDetails({ ...x });
  }

  function setrequired(key) {
    var x = details;
    x[key].required = true;
    setDetails({ ...x });
  }

  function setnotrequired(key) {
    var x = details;
    x[key].required = false;
    setDetails({ ...x });
  }

  function sethidden(key) {
    var x = details;
    x[key].visible = false;
    setDetails({ ...x });
  }

  function onFinish(values) {
    next();
  }

  function getFormData() {
    var url = window.API_PREFIX + "forms/api/get/all";
    const requestOptions = {
      data: sessionStorage.getItem("token"),
    };
    axios.post(url, requestOptions).then((res) => {
      if (res.data.status == 200) {
        ////////////////////////////////// setting details (step 1) form if it has been already filled by user //////////////////////////////////////////////////////////
        var application_data = res.data.application_data;
        var initial = details;
        let application_obj_keys = Object.keys(initial);
        for (var i = 0; i < application_obj_keys.length; i++) {
          if (Object.keys(application_data).includes(application_obj_keys[i])) {
            initial[application_obj_keys[i]]["value"] =
              application_data[application_obj_keys[i]];
          }
        }
        initial["dateOfBirth"]["value"] = dayjs(
          initial["dateOfBirth"]["value"]
        );
        setDetails(initial);
      } else if (res.data.status == 401) {
        sessionStorage.clear();
        window.location = "/Expired";
      }
    });
  }

  const userRole = sessionStorage.getItem("role");

  return (
    <>
      <Formik
        initialValues={details}
        onSubmit={(values) => {
          setLoading(true);

          let details1 = details;
          // details1["dateOfBirth"].value= moment(details1["dateOfBirth"].value).format("YYYY-MM-DD")
          var url = window.API_PREFIX + "forms/api/post/application";
          const requestOptions = {
            data: details1,
            user: sessionStorage.getItem("username"),
            token: sessionStorage.getItem("token"),
          };
          axios
            .post(url, requestOptions)
            .then((res) => {
              if (res.data.status == 200) {
                setAlertType("success");
                setAlertMessage(res.data.info);
                setAlertVisible(true);
                setApplicationId(res.data.applicationId);
                sessionStorage.setItem("applicationId", res.data.applicationId);
                setStepDisable(false);
              } else if (res.data.status == 409) {
                setAlertType("info");
                setAlertMessage(res.data.info);
                setAlertVisible(true);
              }
              setStepIsValid({
                ...stepIsValid,
                personalDetails: "finish",
              });
              if (!sessionStorage.getItem("applciationId")) {
                sessionStorage.setItem(
                  "applicationId",
                  res.data.application_id
                );
              }
              onFinish();
            })
            .catch((err) => {
              message.error(
                "Please fill the correct information. Try again after refreshing the page",
                10
              );
              setStepIsValid({
                ...stepIsValid,
                personalDetails: "error",
              });
            })
            .finally(() => {
              setLoading(false);
            });
        }}
        validateOnChange={true}
        validateOnBlur={true}
        validate={(values) => {
          const errors = {};
          values = details;
          Object.keys(values).map((key) => {
            if (
              values[key]["required"] &&
              (values[key]["value"] === "" || values[key]["value"] === null)
            ) {
              errors[key] = _.capitalize(values[key]["label"]) + " is required";
            }

            if (values[key]["label"].toLowerCase().includes("pin")) {
              const pinValue = values[key]["value"];
              if (!/^\d{6}$/.test(pinValue)) {
                errors[key] =
                  _.capitalize(values[key]["label"]) +
                  " must be a 6-digit number";
              }
            }

            if (values[key]["label"] == "Annual Family Income (INR)") {
              const familyIncome = values[key]["value"];
              if (familyIncome > 500000) {
                errors[key] =
                  _.capitalize(values[key]["label"]) +
                  " cannot be greater than ₹5,00,000.";
              }
              if (familyIncome < 0) {
                errors[key] =
                  _.capitalize(values[key]["label"]) +
                  " cannot be less than ₹0";
              }
            }

            if (values[key]["label"] == "Father/Mother Phone") {
              const mobileValue = values[key]["value"];
              if (!/^\d{10}$/.test(mobileValue)) {
                errors[key] =
                  _.capitalize(values[key]["label"]) +
                  " must be a 10-digit number";
              }
            }

            if (values[key]["label"].toLowerCase().includes("landline")) {
              const landlineValue = values[key]["value"];
              if (!/^\d{10}$/.test(landlineValue)) {
                errors[key] =
                  _.capitalize(values[key]["label"]) +
                  " must be a 10-digit number";
              }
            }

            if (values[key]["label"].toLowerCase().includes("mobile")) {
              const mobileValue = values[key]["value"];
              if (!/^\d{10}$/.test(mobileValue)) {
                errors[key] =
                  _.capitalize(values[key]["label"]) +
                  " must be a 10-digit number";
              }
            }

            if (key === "fatherMotherPAN") {
              const panValue = values[key]["value"];
              if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(panValue)) {
                errors[key] =
                  _.capitalize(values[key]["label"]) +
                  " must be a valid PAN number";
              }
            }

            if (key === "domicileSince") {
              const domicileSince = values[key]["value"];
              if (!/^\d+$/.test(domicileSince)) {
                errors[key] =
                  _.capitalize(values[key]["label"]) +
                  " must be a valid number";
              }
            }

            if (key === "dateOfBirth") {
              const dateOfBirth = new Date(values[key]["value"]);
              const today = new Date();
              let age = today.getFullYear() - dateOfBirth.getFullYear();
              const monthDifference = today.getMonth() - dateOfBirth.getMonth();
              if (
                monthDifference < 0 ||
                (monthDifference === 0 &&
                  today.getDate() < dateOfBirth.getDate())
              ) {
                age--;
              }
              if (age < 16) {
                errors[key] =
                  _.capitalize(values[key]["label"]) +
                  " must be at least 16 years old";
              }
            }

            if (
              key === "currentContactPersonEmail" ||
              key === "permanentContactPersonEmail" ||
              key === "fatherMotherEmail"
            ) {
              const emailValue = values[key]["value"];
              const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
              if (!emailRegex.test(emailValue)) {
                errors[key] =
                  _.capitalize(values[key]["label"]) +
                  " must be a valid email address";
              }
            }
          });

          return errors;
        }}
      >
        {({ handleSubmit, errors, touched, dirty, validateField }) => {
          return (
            <>
              <Row
                gutter={[10, 10]}
                style={{
                  marginLeft: "50px",
                  marginRight: "5px",
                }}
              >
                {Object.keys(details).map((item) => {
                  return (
                    <>
                      <Col md={details[item].col}>
                        {details[item].type == "text" &&
                        details[item].field_set == "Personal Details" &&
                        details[item].visible ? (
                          <>
                            <label>
                              {details[item].label}{" "}
                              {details[item].required ? (
                                <span style={{ color: "red" }}>*</span>
                              ) : null}
                            </label>
                            <Input
                              placeholder={details[item].label}
                              name={`${item}.value`}
                              value={details[item].value}
                              onChange={(e) => {
                                setvalue(item, e.target.value);
                              }}
                            />
                            {errors[item] &&
                            item in touched &&
                            touched[item]["value"] ? (
                              <div style={{ color: "red" }}>{errors[item]}</div>
                            ) : null}
                          </>
                        ) : (
                          <>
                            {details[item].type == "radio" &&
                            details[item].field_set == "Personal Details" &&
                            details[item].visible ? (
                              <>
                                <label>
                                  {details[item].label}{" "}
                                  {details[item].required ? (
                                    <span style={{ color: "red" }}>*</span>
                                  ) : null}
                                </label>
                                <Radio.Group
                                  onChange={(e) => {
                                    setvalue(item, e.target.value);
                                  }}
                                  value={details[item].value}
                                  name={`${item}.value`}
                                >
                                  <Space direction="horizontal">
                                    {details[item].radio_item.map((item) => {
                                      return <Radio value={item}>{item}</Radio>;
                                    })}
                                  </Space>
                                </Radio.Group>
                                {errors[item] &&
                                item in touched &&
                                !details[item]["value"] &&
                                touched[item]["value"] ? (
                                  <div style={{ color: "red" }}>
                                    {errors[item]}
                                  </div>
                                ) : null}
                              </>
                            ) : (
                              <>
                                {details[item].type == "date" &&
                                details[item].field_set == "Personal Details" &&
                                details[item].visible ? (
                                  <>
                                    <label>
                                      {details[item].label}{" "}
                                      {details[item].required ? (
                                        <span style={{ color: "red" }}>*</span>
                                      ) : null}
                                    </label>
                                    <DatePicker
                                      name={`${item}.value`}
                                      value={details[item].value}
                                      style={{ height: "auto", width: "100%" }}
                                      onChange={onChangeDOB}
                                    />
                                    {errors[item] &&
                                    item in touched &&
                                    touched[item]["value"] ? (
                                      <div style={{ color: "red" }}>
                                        {errors[item]}
                                      </div>
                                    ) : null}
                                  </>
                                ) : (
                                  item === "placeOfBirth" && (
                                    <>
                                      <Col md={details[item].col * 3} xs={24}>
                                        <label>
                                          {details[item].label}{" "}
                                          {details[item].required ? (
                                            <span style={{ color: "red" }}>
                                              *
                                            </span>
                                          ) : null}
                                        </label>
                                        <Select
                                          showSearch
                                          placeholder="Select city"
                                          optionFilterProp="label"
                                          value={details[item].value}
                                          onChange={(val) => {
                                            setvalue(item, val);
                                            if (addressChecked) {
                                              setvalue(
                                                details[item].copyTo,
                                                val
                                              );
                                            }
                                          }}
                                          style={{
                                            width: "100%",
                                          }}
                                          options={cityOptions}
                                        />
                                        {errors[item] &&
                                        item in touched &&
                                        touched[item]["value"] ? (
                                          <div style={{ color: "red" }}>
                                            {errors[item]}
                                          </div>
                                        ) : null}
                                      </Col>
                                    </>
                                  )
                                )}
                              </>
                            )}
                          </>
                        )}
                      </Col>
                    </>
                  );
                })}
              </Row>
              {/*--------------------------Address Details------------------------- */}
              <Divider orientation="left" orientationMargin={50}>
                <Typography.Title level={3}>Address Details</Typography.Title>
              </Divider>
              <Row
                gutter={[10, 10]}
                style={{
                  paddingLeft: "3.125rem",
                }}
              >
                <Col xs={12} sm={12} md={9} lg={9} xl={9}>
                  <Row gutter={[10, 10]}>
                    {Object.keys(details).map((item) => {
                      return (
                        <>
                          {(details[item].type == "text" ||
                            details[item].type == "number") &&
                          details[item].field_set == "Current Address" &&
                          details[item].visible ? (
                            <>
                              <Col md={details[item].col * 3} xs={24}>
                                <label>
                                  {details[item].label}{" "}
                                  {details[item].required ? (
                                    <span style={{ color: "red" }}>*</span>
                                  ) : null}
                                </label>
                                <Input
                                  placeholder={details[item].label}
                                  name={`${item}.value`}
                                  type={details[item].type}
                                  value={details[item].value}
                                  min={0}
                                  onChange={(e) => {
                                    setvalue(item, e.target.value);
                                    if (addressChecked) {
                                      setvalue(
                                        details[item].copyTo,
                                        e.target.value
                                      );
                                    }
                                  }}
                                />
                                {errors[item] &&
                                item in touched &&
                                touched[item]["value"] ? (
                                  <div style={{ color: "red" }}>
                                    {errors[item]}
                                  </div>
                                ) : null}
                              </Col>
                            </>
                          ) : (
                            item === "currentState" && (
                              <>
                                <Col md={details[item].col * 3} xs={24}>
                                  <label>
                                    {details[item].label}{" "}
                                    {details[item].required ? (
                                      <span style={{ color: "red" }}>*</span>
                                    ) : null}
                                  </label>
                                  <Select
                                    showSearch
                                    placeholder="Select state"
                                    optionFilterProp="label"
                                    value={details[item].value}
                                    onChange={(val) => {
                                      setvalue(item, val);
                                      if (addressChecked) {
                                        setvalue(details[item].copyTo, val);
                                      }
                                    }}
                                    style={{
                                      width: "100%",
                                    }}
                                    options={stateOptions}
                                  />
                                  {errors[item] &&
                                  item in touched &&
                                  touched[item]["value"] ? (
                                    <div style={{ color: "red" }}>
                                      {errors[item]}
                                    </div>
                                  ) : null}
                                </Col>
                              </>
                            )
                          )}
                        </>
                      );
                    })}
                  </Row>
                </Col>
                <Col xs={12} sm={24} md={3} lg={3} xl={3}>
                  <Space
                    align="center"
                    direction="vertical"
                    style={{ height: "100%", justifyContent: "center" }}
                  >
                    {/* center */}
                    <Checkbox name="address" onChange={onAddressCheckChange}>
                      Same as Current
                    </Checkbox>
                  </Space>
                </Col>
                <Col xs={12} sm={12} md={9} lg={9} xl={9}>
                  <Row gutter={[10, 10]}>
                    {Object.keys(details).map((item) => {
                      return (
                        <>
                          {(details[item].type == "text" ||
                            details[item].type == "number") &&
                          details[item].field_set == "Permanent Address" &&
                          details[item].visible ? (
                            <>
                              <Col md={details[item].col * 3} xs={24}>
                                <label>
                                  {details[item].label}{" "}
                                  {details[item].required ? (
                                    <span style={{ color: "red" }}>*</span>
                                  ) : null}
                                </label>
                                <Input
                                  placeholder={details[item].label}
                                  name={`${item}.value`}
                                  type={details[item].type}
                                  value={details[item].value}
                                  onChange={(e) => {
                                    setvalue(item, e.target.value);
                                  }}
                                  min={0}
                                />
                                {errors[item] &&
                                item in touched &&
                                touched[item]["value"] ? (
                                  <div style={{ color: "red" }}>
                                    {errors[item]}
                                  </div>
                                ) : null}
                              </Col>
                            </>
                          ) : (
                            item === "permanentState" && (
                              <>
                                <Col md={details[item].col * 3} xs={24}>
                                  <label>
                                    {details[item].label}{" "}
                                    {details[item].required ? (
                                      <span style={{ color: "red" }}>*</span>
                                    ) : null}
                                  </label>
                                  <Select
                                    showSearch
                                    placeholder="Select state"
                                    optionFilterProp="label"
                                    value={details[item].value}
                                    onChange={(val) => {
                                      setvalue(item, val);
                                      if (addressChecked) {
                                        setvalue(details[item].copyTo, val);
                                      }
                                    }}
                                    style={{
                                      width: "100%",
                                    }}
                                    options={stateOptions}
                                  />
                                  {errors[item] &&
                                  item in touched &&
                                  touched[item]["value"] ? (
                                    <div style={{ color: "red" }}>
                                      {errors[item]}
                                    </div>
                                  ) : null}
                                </Col>
                              </>
                            )
                          )}
                        </>
                      );
                    })}
                  </Row>
                </Col>
              </Row>
              {/*---------------------------Contact Information-------------------------*/}
              <Divider orientation="left" orientationMargin={50}>
                <Typography.Title level={3}>
                  Contact Information
                </Typography.Title>
              </Divider>
              <Row
                gutter={[10, 10]}
                style={{
                  paddingLeft: "3.125rem",
                }}
              >
                <Col xs={12} sm={12} md={9} lg={9} xl={9}>
                  <Divider orientation="left" orientationMargin={50}>
                    <Typography.Title level={5} type="secondary">
                      Current Contact Information
                    </Typography.Title>
                  </Divider>
                  <Row gutter={[10, 10]}>
                    {Object.keys(details).map((item) => {
                      return (
                        <>
                          {(details[item].type == "text" ||
                            details[item].type == "number") &&
                          details[item].field_set ==
                            "Current Contact Information" &&
                          details[item].visible ? (
                            <>
                              <Col md={details[item].col * 3} xs={24}>
                                <label>
                                  {details[item].label}{" "}
                                  {details[item].required ? (
                                    <span style={{ color: "red" }}>*</span>
                                  ) : null}
                                </label>
                                <Input
                                  placeholder={details[item].label}
                                  onChange={(e) => {
                                    setvalue(item, e.target.value);
                                    if (contactInfoChecked) {
                                      setvalue(
                                        details[item].copyTo,
                                        e.target.value
                                      );
                                    }
                                  }}
                                  name={`${item}.value`}
                                  value={details[item].value}
                                />
                                {errors[item] &&
                                item in touched &&
                                touched[item]["value"] ? (
                                  <div style={{ color: "red" }}>
                                    {errors[item]}
                                  </div>
                                ) : null}
                              </Col>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      );
                    })}
                  </Row>
                </Col>
                <Col xs={12} sm={24} md={3} lg={3} xl={3}>
                  <Space
                    align="center"
                    direction="vertical"
                    style={{ height: "100%", justifyContent: "center" }}
                  >
                    {/* center */}
                    <Checkbox name="contact" onChange={onContactCheckChange}>
                      Same as Current
                    </Checkbox>
                  </Space>
                </Col>
                <Col xs={12} sm={12} md={9} lg={9} xl={9}>
                  <Divider orientation="left" orientationMargin={50}>
                    <Typography.Title type="secondary" level={5}>
                      Permanent Contact Information
                    </Typography.Title>
                  </Divider>
                  <Row gutter={[10, 10]}>
                    {Object.keys(details).map((item) => {
                      return (
                        <>
                          {(details[item].type == "text" ||
                            details[item].type == "number") &&
                          details[item].field_set ==
                            "Permanent Contact Information" &&
                          details[item].visible ? (
                            <>
                              <Col md={details[item].col * 3} xs={24}>
                                <label>
                                  {details[item].label}{" "}
                                  {details[item].required ? (
                                    <span style={{ color: "red" }}>*</span>
                                  ) : null}
                                </label>
                                <Input
                                  placeholder={details[item].label}
                                  onChange={(e) => {
                                    setvalue(item, e.target.value);
                                  }}
                                  name={`${item}.value`}
                                  value={details[item].value}
                                />
                                {errors[item] &&
                                item in touched &&
                                touched[item]["value"] ? (
                                  <div style={{ color: "red" }}>
                                    {errors[item]}
                                  </div>
                                ) : null}
                              </Col>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      );
                    })}
                  </Row>
                </Col>
              </Row>

              {/*---------------------------Family Details-------------------------*/}
              <Divider orientation="left" orientationMargin={50}>
                <Typography.Title level={3}>
                  Basic Family Details
                </Typography.Title>
              </Divider>
              <Row
                gutter={[10, 10]}
                style={{ marginLeft: "50px", marginRight: "5px" }}
              >
                {Object.keys(details).map((item) => {
                  return (
                    <>
                      {details[item].type == "text" &&
                      details[item].field_set == "Basic Family Details" ? (
                        <>
                          <Col md={details[item].col} xs={24}>
                            <label>
                              {details[item].label}{" "}
                              {details[item].required ? (
                                <span style={{ color: "red" }}>*</span>
                              ) : null}
                            </label>
                            <Input
                              placeholder={details[item].label}
                              onChange={(e) => {
                                setvalue(item, e.target.value);
                              }}
                              name={`${item}.value`}
                              value={details[item].value}
                            />
                            {errors[item] &&
                            item in touched &&
                            touched[item]["value"] ? (
                              <div style={{ color: "red" }}>{errors[item]}</div>
                            ) : null}
                          </Col>
                        </>
                      ) : (
                        (item === "domicileStateOfOrigin" ||
                          item === "domicileState") && (
                          <Col
                            md={3}
                            xs={24}
                            style={{
                              position: "relative",
                            }}
                          >
                            <label>
                              {details[item].label}{" "}
                              {details[item].required ? (
                                <span style={{ color: "red" }}>*</span>
                              ) : null}
                            </label>
                            <Select
                              showSearch
                              style={{
                                width: "100%",
                              }}
                              placeholder="Select state"
                              optionFilterProp="label"
                              value={details[item].value}
                              onChange={(val) => {
                                setvalue(item, val);
                                if (addressChecked) {
                                  setvalue(details[item].copyTo, val);
                                }
                              }}
                              options={stateOptions}
                            />
                            {errors[item] &&
                            item in touched &&
                            touched[item]["value"] ? (
                              <div style={{ color: "red" }}>{errors[item]}</div>
                            ) : null}
                          </Col>
                        )
                      )}
                    </>
                  );
                })}
              </Row>
              {/*---------------------------Economical Details-------------------------*/}
              <Divider orientation="left" orientationMargin={50}>
                <Typography.Title level={3}>
                  Economical Details
                </Typography.Title>
              </Divider>
              <Row
                gutter={[10, 10]}
                style={{ marginLeft: "50px", marginRight: "5px" }}
              >
                {Object.keys(details).map((item) => {
                  return (
                    <>
                      {details[item].type == "text" &&
                      details[item].field_set == "Economical Details" &&
                      details[item].visible ? (
                        <>
                          <Col md={details[item].col} xs={24}>
                            <label>
                              {details[item].label}{" "}
                              {details[item].required ? (
                                <span style={{ color: "red" }}>*</span>
                              ) : null}
                            </label>
                            <Input
                              placeholder={details[item].label}
                              onChange={(e) => {
                                setvalue(item, e.target.value);
                              }}
                              name={`${item}.value`}
                              value={details[item].value}
                            />
                            {errors[item] &&
                            item in touched &&
                            touched[item]["value"] ? (
                              <div style={{ color: "red" }}>{errors[item]}</div>
                            ) : null}
                          </Col>
                        </>
                      ) : (
                        <>
                          {details[item].type == "radio" &&
                          details[item].field_set == "Economical Details" &&
                          details[item].visible ? (
                            <>
                              <Col md={details[item].col} xs={24}>
                                <label>
                                  {details[item].label}{" "}
                                  {details[item].required ? (
                                    <span style={{ color: "red" }}>*</span>
                                  ) : null}
                                </label>
                                <Radio.Group
                                  onChange={(e) => {
                                    if (
                                      item == "cultivableLand" &&
                                      e.target.value == true
                                    ) {
                                      setvisible("landAcres");
                                      setrequired("landAcres");
                                    } else if (
                                      item == "cultivableLand" &&
                                      e.target.value == false
                                    ) {
                                      sethidden("landAcres");
                                      setnotrequired("landAcres");
                                    }
                                    setvalue(item, e.target.value);
                                  }}
                                  value={details[item].value}
                                  name={`${item}.value`}
                                >
                                  <Space direction="horizontal">
                                    <Radio value={true}>Yes</Radio>
                                    <Radio value={false}>No</Radio>
                                  </Space>
                                </Radio.Group>
                                {errors[item] &&
                                item in touched &&
                                !details[item]["value"] &&
                                touched[item]["value"] ? (
                                  <div style={{ color: "red" }}>
                                    {errors[item]}
                                  </div>
                                ) : null}
                              </Col>
                            </>
                          ) : (
                            <>
                              {details[item].type == "number" &&
                              details[item].field_set == "Economical Details" &&
                              details[item].visible ? (
                                <>
                                  <Col md={details[item].col} xs={24}>
                                    <label>
                                      {details[item].label}{" "}
                                      {details[item].required ? (
                                        <span style={{ color: "red" }}>*</span>
                                      ) : null}
                                    </label>
                                    <Input
                                      type="number"
                                      style={{ width: "100%" }}
                                      min={0}
                                      placeholder={details[item].label}
                                      onChange={(e) => {
                                        onChangeNumber(item, e.target.value);
                                      }}
                                      name={`${item}.value`}
                                      value={details[item].value}
                                    />
                                    {errors[item] &&
                                    item in touched &&
                                    touched[item]["value"] ? (
                                      <div style={{ color: "red" }}>
                                        {errors[item]}
                                      </div>
                                    ) : null}
                                  </Col>
                                </>
                              ) : (
                                <>
                                  {details[item].type == "select" &&
                                  details[item].field_set ==
                                    "Economical Details" &&
                                  details[item].visible ? (
                                    <>
                                      <Col md={details[item].col} xs={24}>
                                        <label>
                                          {details[item].label}{" "}
                                          {details[item].required ? (
                                            <span style={{ color: "red" }}>
                                              *
                                            </span>
                                          ) : null}
                                        </label>
                                        <Select
                                          name={`${item}.value`}
                                          style={{ width: "100%" }}
                                          placeholder={details[item].label}
                                          onChange={(e) => {
                                            setvalue(item, e);
                                            if (e == "Rented") {
                                              setvisible("monthlyRent");
                                              setrequired("monthlyRent");
                                            } else {
                                              sethidden("monthlyRent");
                                              setnotrequired("monthlyRent");
                                            }
                                          }}
                                          defaultValue={details[item].value}
                                        >
                                          <Select.Option value={"Rented"}>
                                            Rented
                                          </Select.Option>
                                          <Select.Option value={"Owned"}>
                                            Owned
                                          </Select.Option>
                                          <Select.Option value={"Other"}>
                                            Other
                                          </Select.Option>
                                        </Select>
                                        {errors[item] &&
                                        item in touched &&
                                        touched[item]["value"] ? (
                                          <div style={{ color: "red" }}>
                                            {errors[item]}
                                          </div>
                                        ) : null}
                                      </Col>
                                    </>
                                  ) : null}
                                </>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </>
                  );
                })}
              </Row>
              <Row gutter={[10, 10]} style={{ margin: "50px" }}>
                <Space direction="vertical" style={{ width: "100%" }}>
                  {alertVisible && (
                    <Alert
                      message={alertMessage}
                      type={alertType}
                      closable
                      afterClose={handleClose}
                    />
                  )}
                  {alertVisible}
                </Space>
              </Row>
              <Row gutter={[10, 10]} style={{ margin: "50px" }}>
                {userRole !== "Verifier" && (
                  <Col>
                    <Button type={"primary"} onClick={handleSubmit}>
                      Save
                    </Button>
                  </Col>
                )}
                {/* <Col>
                <Button type={"success"} onClick={onFinish}>
                  Next
                </Button>
              </Col> */}
              </Row>
              {/* <FormikDebug style={{ maxWidth: 400 }} /> */}
            </>
          );
        }}
      </Formik>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};
export default Details;
